module.exports = __webpack_public_path__ + "static/media/brand-logo-inverse-light.13ef2a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-logo-inverse-light.png
// module id = 33
// module chunks = 1